import { Typography } from "@mui/material";

export default function OmagunTitle({ children, light = false, sx = {} }) {
  return (
    <Typography
      component="h1"
      sx={{
        pt: 8,
        pb: 5,
        px: 2,
        textAlign: "center",
        fontFamily: '"TamanegiKaishoGeki", "Kaisei Decol", serif',
        fontSize: "clamp(34px, 11vw, 48px)",
        lineHeight: 1.1,
        letterSpacing: ".08em",
        color: light ? "#890000" : "#fff",
        textShadow: light
          ? "1px 2px 0 rgba(255,255,255,.55)"
          : "0 3px 0 #000, 0 0 7px rgba(255,255,255,.55)",
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
}
